module.exports = __webpack_public_path__ + "res/ic_menu_digital_display_s.703be9b6783af28cb94db6d0724db9a8.png";